import styled from 'styled-components';
import { IMAGE_HEIGHT, IMAGE_WIDTH } from '../constants';

export const StyledFileDeleteAction = styled.div`
  display: none;
  opacity: 0;
  padding: 2px 4px;
  position: absolute;
  top: 0px;
  right: 0px;
  transition: opacity 0.3s linear;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  z-index: 1;

  &:hover {
    color: ${({ theme }) => theme.color.status.error};
  }
`;

export const StyledMetadataOverlay = styled.div`
  width: 100%;
  height: 90px;
  padding: 8px;
  background: ${({ theme }) => theme.color.overlay.light};
  color: ${({ theme }) => theme.color.type.primary};
  font-size: 0.75rem;
  line-height: 1.4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 1;
  transition: opacity 0.3s linear;
  z-index: 2;

  span {
    display: block;
    color: #000000 !important;
    max-width: 100%;
    font-size: 0.75rem;
    text-align: center;
  }

  span:first-of-type {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }
`;

export const StyledMask = styled.div`
  position: absolute;
  display: none;
  opacity: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  // following styles taken from .ant-image-mask class
  background: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s linear;
  cursor: pointer;
`;

export const StyledFileTileBody = styled.div`
  position: relative;
  width: ${IMAGE_WIDTH * 2}px;
  height: ${IMAGE_HEIGHT * 2}px;
  user-select: none;

  .ant-image {
    padding: 2px;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    i {
      font-size: 32px;
    }
  }

  &:hover {
    ${StyledFileDeleteAction} {
      display: block;
      opacity: 1;
    }
    ${StyledMask} {
      display: block;
      opacity: 1;
    }
    ${StyledMetadataOverlay} {
      display: none;
      opacity: 0;
    }
  }
`;

export const StyledFileTileLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${IMAGE_WIDTH * 2}px;
  border: 1px solid ${({ theme }) => theme.color.separators.border};
  text-align: center;

  span {
    max-width: ${IMAGE_WIDTH * 2}px;
    font-size: 0.75rem;
  }

  span:first-of-type {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  &:focus {
    outline: none;

    ${StyledFileTileBody} {
      box-sizing: border-box;
      border: 1px solid ${({ theme }) => theme.color.theme.primary};
    }

    span {
      color: ${({ theme }) => theme.color.theme.primary};
    }
  }
`;

export const StyledSortButtonWrapper = styled.div`
  button {
    min-width: 100px;
  }

  .ant-dropdown-trigger {
    box-shadow: none;
    border-color: transparent;
  }

  .ant-dropdown-open {
    border-color: ${({ theme }) => theme.color.theme.primary};
  }
`;

export const StyledRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  ::after {
    flex: 1;
    content: '';
  }
`;

export const StyledCenter = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
